(() => {
  const market = location.pathname.match(/\/origin-(usa|uk|dubai|china)(?:\/|$)/)?.[1];
  const grid = document.querySelector('[data-collection-grid]');
  if (!market || !grid || location.search.includes('filter.') || new URLSearchParams(location.search).has('sort_by')) return;
  const endpoint = '/apps/salibay-search';
  const products = new Map();
  const queue = [];
  let page = 1;
  let busy = false;
  let fresh = false;
  let failed = false;
  const section = document.createElement('section');
  section.className = 'salibay-market-feed';
  section.innerHTML = '<h2>Shop international products</h2><p role="status" data-market-status>Loading products...</p><div class="salibay-product-grid" data-market-grid></div><button type="button" class="btn-secondary" data-market-more>Load more products</button>';
  section.querySelector('h2').textContent = `Shop products from ${{usa:'the US', uk:'the UK', dubai:'Dubai', china:'China'}[market]}`;
  grid.parentElement.insertBefore(section, grid);
  const target = section.querySelector('[data-market-grid]');
  const status = section.querySelector('[data-market-status]');
  const more = section.querySelector('[data-market-more]');
  const escape = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => `KES ${new Intl.NumberFormat('en-KE', {maximumFractionDigits:0}).format(value)}`;
  function enqueue(items,sourcePage=1) {
    for (const product of items) {
      if (!product.publicId || !product.imageUrl || !Number.isFinite(product.price) || products.has(product.publicId)) continue;
      products.set(product.publicId, product);
      queue.push({...product,navigationMarket:market,navigationPage:sourcePage});
    }
  }
  function render() {
    for (const product of queue.splice(0,20)) {
      const card = window.SalibayProductCards.create(product,{market,page:product.navigationPage});
      card.classList.add('market-product-card');
      card.dataset.marketProduct=product.publicId;
      target.append(card);
    }
    more.hidden = !queue.length && !page;
  }
  const cacheKey = `salibay-market:v3:${market}`;
  try {
    const saved = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
    if (saved && Date.now() - saved.savedAt < 21_600_000) {
      enqueue(saved.feed.products); render(); page = saved.feed.nextPage; fresh = true;
      status.textContent = 'Checking for new products...';
    }
  } catch (_) {}
  async function load(refresh = false) {
    if (busy || (!page && !refresh)) return;
    if (queue.length && !refresh) {render(); return;}
    busy = true; failed = false; more.disabled = true; section.setAttribute('aria-busy','true');
    more.textContent = 'Loading products...';
    status.textContent = fresh ? 'Loading more products...' : 'Loading products...';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 45_000);
    try {
      const sourcePage=refresh ? 1 : page;
      const response = await fetch(`${endpoint}/discover?market=${market}&page=${sourcePage}`, {signal:controller.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Marketplace unavailable');
      const feed = await response.json();
      if (!Array.isArray(feed.products) || !feed.products.length) throw new Error('No fresh products');
      if (refresh) {
        // Replace only after a complete fresh response, never while waiting.
        products.clear(); queue.length = 0; target.replaceChildren();
        try {sessionStorage.setItem(cacheKey, JSON.stringify({savedAt:Date.now(), feed}));} catch (_) {}
      }
      enqueue(feed.products,sourcePage); page = feed.nextPage; fresh = true; render();
      more.textContent = 'Load more products';
      status.textContent = feed.selection === 'best-sellers' ? 'Shop popular best-selling products' : 'Explore more products from this country';
    } catch (_) {
      failed = true;
      status.textContent = 'More products could not load. You can shop the products below or try again.';
      more.hidden = false; more.textContent = 'Try again';
      observer?.disconnect();
    } finally {
      clearTimeout(timeout); busy = false; more.disabled = false; section.removeAttribute('aria-busy');
      if (!failed && !more.hidden) { observer?.unobserve(more); observer?.observe(more); }
    }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && fresh) load();
  }, {rootMargin:'300px'}) : null;
  more.addEventListener('click', () => load());
  observer?.observe(more);
  load(true);
})();
